import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';

import Stonks from './stocks.js';
import Bubbles from './bubbles.js';

import './App.css';

const App = () => (
	<Router>
		<Routes>
        	<Route exact path="/bubbles" element={<Bubbles />}/>
			<Route path="/stocks" element={<Stonks />}/>
      </Routes>
    </Router>
);

export default App;
